export enum FileUploadActionTypes {
  UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE',
  UPLOAD_FILE_PROGRESS = 'UPLOAD_FILE_PROGRESS',

  FETCH_FILES_REQUEST = 'FETCH_FILES_REQUEST',
  FETCH_FILES_SUCCESS = 'FETCH_FILES_SUCCESS',
  FETCH_FILES_FAILURE = 'FETCH_FILES_FAILURE',

  DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST',
  DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE',

  DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST',
  DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS',
  DOWNLOAD_FILE_FAILURE = 'DOWNLOAD_FILE_FAILURE',
}

export interface FileUploadData {
  file: File;
  prescID?: number;
  licensesID?: number;
  tempId: string;
  entityType: 'prescription' | 'license';
}

export interface UploadedFileInfo {
  id: number;
  documentId: string;
  name: string;
  url: string;
  size: number;
  mime: string;
  prescID?: number;
  licensesID?: number;
  uploadId?: number;
  progress?: number;
  isUploading?: boolean;
  tempId?: string;
}


export const uploadFileRequest = (fileData: FileUploadData) => ({
  type: FileUploadActionTypes.UPLOAD_FILE_REQUEST,
  payload: fileData,
});

export const uploadFileSuccess = (fileInfo: UploadedFileInfo) => ({
  type: FileUploadActionTypes.UPLOAD_FILE_SUCCESS,
  payload: fileInfo,
});

export const uploadFileFailure = (error: string, tempId: string) => ({
  type: FileUploadActionTypes.UPLOAD_FILE_FAILURE,
  payload: { error, tempId },
});

export const uploadFileProgress = (progress: number, tempId: string) => ({
  type: FileUploadActionTypes.UPLOAD_FILE_PROGRESS,
  payload: { progress, tempId },
});

export const fetchFilesRequest = (prescID?: number, licensesID?: number, entityType?: 'prescription' | 'license') => ({
  type: FileUploadActionTypes.FETCH_FILES_REQUEST,
  payload: { prescID, licensesID, entityType },
});

export const fetchFilesSuccess = (files: UploadedFileInfo[]) => ({
  type: FileUploadActionTypes.FETCH_FILES_SUCCESS,
  payload: files,
});

export const fetchFilesFailure = (error: string) => ({
  type: FileUploadActionTypes.FETCH_FILES_FAILURE,
  payload: { error },
});

export const deleteFileRequest = (
  documentId: string,
  uploadId: number,
  entityType?: 'prescription' | 'license',
  prescID?: number,
  licensesID?: number
) => ({
  type: FileUploadActionTypes.DELETE_FILE_REQUEST,
  payload: { documentId, uploadId, entityType, prescID, licensesID },
});

export const deleteFileSuccess = (documentId: string, uploadId: number) => ({
  type: FileUploadActionTypes.DELETE_FILE_SUCCESS,
  payload: { documentId, uploadId },
});

export const deleteFileFailure = (error: string) => ({
  type: FileUploadActionTypes.DELETE_FILE_FAILURE,
  payload: { error },
});

export const downloadFileRequest = (fileInfo: UploadedFileInfo) => ({
  type: FileUploadActionTypes.DOWNLOAD_FILE_REQUEST,
  payload: fileInfo,
});

export const downloadFileSuccess = () => ({
  type: FileUploadActionTypes.DOWNLOAD_FILE_SUCCESS,
});

export const downloadFileFailure = (error: string) => ({
  type: FileUploadActionTypes.DOWNLOAD_FILE_FAILURE,
  payload: { error },
});

export type FileUploadAction =
  | ReturnType<typeof uploadFileRequest>
  | ReturnType<typeof uploadFileSuccess>
  | ReturnType<typeof uploadFileFailure>
  | ReturnType<typeof uploadFileProgress>
  | ReturnType<typeof fetchFilesRequest>
  | ReturnType<typeof fetchFilesSuccess>
  | ReturnType<typeof fetchFilesFailure>
  | ReturnType<typeof deleteFileRequest>
  | ReturnType<typeof deleteFileSuccess>
  | ReturnType<typeof deleteFileFailure>
  | ReturnType<typeof downloadFileRequest>
  | ReturnType<typeof downloadFileSuccess>
  | ReturnType<typeof downloadFileFailure>;
